import { createFileRoute } from "@tanstack/react-router";
import { browseDogsFindRetentionRoute } from "@/app-clients/browse-dogs/routes/find-retention-layout";

export const Route = createFileRoute("/_find")({
    ...browseDogsFindRetentionRoute,
});
